import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { INK_SOFT, ctaGlowSx } from "../../theme/brand";
import { REGISTER_URL } from "../../config";

export default function CtaBand() {
  return (
    <Box sx={{ bgcolor: INK_SOFT, color: "#fff", py: { xs: 8, md: 10 } }}>
      <Container maxWidth="md" sx={{ textAlign: "center" }}>
        <Typography variant="h4" component="h2" fontWeight={800} sx={{ mb: 1.5 }}>
          Bereit für weniger Papierkram?
        </Typography>
        <Typography sx={{ color: "rgba(255,255,255,0.6)", mb: 4 }}>
          Teste MartialVerse 1 Monat kostenlos – einrichten, ausprobieren,
          entscheiden.
        </Typography>
        <Button
          href={REGISTER_URL}
          variant="contained"
          size="large"
          sx={{ px: 5, py: 1.5, fontWeight: 700, ...ctaGlowSx }}
        >
          Jetzt kostenlos testen
        </Button>
      </Container>
    </Box>
  );
}
